import React from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '../../model/icons';
import '../../styles/modal.css';

// Модалка новой верстки (scrim + modal): шапка с заголовком/крестиком, тело, футер.
// Переиспользуемая оболочка — контент и кнопки передаются через props.
// Закрытие по mousedown на подложке (не по click): отпускание мыши за модалкой
// после выделения текста внутри не должно её закрывать.
export default function Modal({ open, title, kicker, onClose, children, footer, size }) {
    if (!open) return null;

    return (
        <div className="scrim show" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div
                className={`modal${size === 'sm' ? ' sm' : ''}${size === 'lg' ? ' lg' : ''}${size === 'xl' ? ' xl' : ''}`}
            >
                <div className="modal-head">
                    <div>
                        {kicker && <div className="kicker mkick">{kicker}</div>}
                        <div className="mtitle">{title}</div>
                    </div>
                    <button type="button" className="x-btn" onClick={onClose} aria-label="Закрыть">
                        <CloseIcon />
                    </button>
                </div>
                <div className="modal-body">
                    <div className="form-grid">{children}</div>
                </div>
                {footer && <div className="modal-foot">{footer}</div>}
            </div>
        </div>
    );
}

Modal.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    kicker: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
    footer: PropTypes.node,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl'])
};

Modal.defaultProps = {
    kicker: null,
    children: null,
    footer: null,
    size: 'md'
};
